import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TaxItem, TaxRate, TaxType, taxTypes } from '@luggagehero/shared/interfaces';
import { TranslateModule } from '@ngx-translate/core';

import { DashboardTaxesCardDeleteButtonComponent } from '../delete-button/dashboard-taxes-card-delete-button.component';

@Component({
  selector: 'lh-dashboard-taxes-card',
  standalone: true,
  imports: [CommonModule, FormsModule, DashboardTaxesCardDeleteButtonComponent, TranslateModule],
  templateUrl: './dashboard-taxes-card.component.html',
  styleUrls: ['./dashboard-taxes-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardTaxesCardComponent implements OnChanges {
  @Input() taxItem?: TaxItem | null;
  @Input() isDraft = false;
  @Output() saveClick: EventEmitter<TaxItem> = new EventEmitter<TaxItem>();
  @Output() deleteClick: EventEmitter<void> = new EventEmitter<void>();
  isLoading = input<boolean>();

  public editModel: TaxItem = { _id: undefined, name: '', taxType: 'sales', rates: [] };
  public taxTypes: TaxType[] = [...taxTypes];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['taxItem'] && changes['taxItem'].currentValue && this.taxItem != null) {
      this.editModel = {
        ...this.taxItem,
        rates: this.taxItem.rates.map((x) => {
          return {
            ...x,
          };
        }),
      };
    }
  }

  addRate(): void {
    this.editModel.rates.push({ rate: 0, validFrom: new Date() } as TaxRate);
  }

  removeRate(index: number): void {
    this.editModel.rates.splice(index, 1);
  }

  onSave(): void {
    this.saveClick.emit(this.editModel);
  }

  onDeleteClick(): void {
    this.deleteClick?.emit();
  }
}
